<template>
  <div id="popups">
    <!-- Content -->
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader class="py-3">
            <h4 class="mb-0">
              Popups
            </h4>
          </CCardHeader>
          <CCardBody>
            <!-- Search -->
            <CRow>
              <CCol col="12">
                <Search @search="updateSearch" />
              </CCol>
            </CRow>
            <CRow>
              <CCol col="12">
                <CRow>
                  <!-- Status -->
                  <CCol
                    md="4"
                    lg="4"
                    xl="3"
                  >
                    <div class="form-group">
                      <Multiselect
                        :value="statusOptions.find(option => option.value == query.status)"
                        :options="statusOptions"
                        label="label"
                        track-by="value"
                        placeholder="Status"
                        @select="(selected) => query.status = selected.value"
                      />
                    </div>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
            <!-- Datatable -->
            <CRow>
              <CCol col="12">
                <DataTable
                  :sorter="query.sorter"
                  :items="datatable.items"
                  :fields="datatable.fields"
                  :enable-export="false"
                  base-route="/popups/edit/"
                  @sorterValue="(event) => (query.sorter = event)"
                  @row-clicked="handleRowClick"
                  @update:checked="updateStatus"
                >
                  <template #actions="{ id }">
                    <DatatableEdit :url="`/popups/edit/${id}`" />
                  </template>
                </DataTable>
              </CCol>
            </CRow>

            <!-- Pagination -->
            <CRow class="mt-2">
              <CCol lg="12">
                <Pagination
                  :page="query.page"
                  :per-page="query.perpage"
                  :pages="pagination.pages"
                  :total="pagination.total"
                  :items="pagination.items"
                  @update:active-page="(page) => (query.page = page)"
                  @update:perpage="(perpage) => (query.perpage = perpage)"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
// Components
import DataTable from '@/components/ui/Datatable'
import DatatableEdit from '@/components/ui/DatatableActions/Edit'
import Pagination from '@/components/ui/Pagination'
import Search from '@/components/ui/Search'
import Multiselect from '@/components/ui/Multiselect'

// Services
import Service from '@/services/popup.service'

export default {
  metaInfo: {
    title: 'Popups',
    titleTemplate: ' %s - Manager - Intelli'
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.state.auth.permissions.includes('manage_popups')) {
        vm.$router.push('/404')
      }
    })
  },

  components: {
    DataTable,
    DatatableEdit,
    Pagination,
    Search,
    Multiselect
  },

  data() {
    return {
      datatable: {
        items: [],
        fields: [
          {
            key: 'status',
            label: 'Status',
            _style: 'width: 5%; min-width: 0px;',
            sorter: false
          },
          {
            key: 'title',
            label: 'Título',
            sorter: true
          },
          {
            key: 'statusTime',
            label: 'Tempo',
            sorter: false
          },
          {
            key: 'begin_at',
            label: 'Exibir',
            sorter: true
          },
          {
            key: 'situation',
            label: 'Situação',
            sorter: false
          },
          {
            key: 'language',
            label: 'Idioma',
            sorter: false
          },
          {
            key: 'actions',
            label: 'Ações',
            sorter: false,
            _style: 'width: 12%; min-width: 0px'
          }
        ]
      },
      query: {
        search: '',
        page: 1,
        perpage: localStorage.getItem('perPageItem')
          ? parseFloat(localStorage.getItem('perPageItem'))
          : 10,
        pagination: true,
        status: null,
        sorter: {
          asc: false,
          column: ''
        }
      },
      pagination: {
        total: 0,
        pages: 0,
        items: 0
      },
      statusOptions: [
        {
          label: 'Todos os status',
          value: null

        },
        {
          label: 'Ativo',
          value: true
        },
        {
          label: 'Inativo',
          value: false
        }
      ],
      rowCliked: {}
    }
  },

  watch: {
    query: {
      handler: 'updateDataTable',
      deep: true
    }
  },

  async created() {
    await this.updateDataTable()
  },

  methods: {
    async updateDataTable() {
      const response = await Service.index(this.query)
      const { data, pagination } = response

      if (data) {
        this.pagination = {
          ...pagination,
          pages: pagination.lastPage,
          items: data.length
        }

        const newItems = response.data.map((item) => {
          return {
            ...item,
            begin_at: item.time
          }
        })

        this.datatable.items = newItems
      }
    },

    async updateSearch(searchText) {
      this.query.search = searchText
      this.query.page = 1

      await this.updateDataTable()
    },

    handleRowClick(event) {
      this.rowCliked = event
    },

    async updateStatus(event) {
      const response = await Service.updateStatus(this.rowCliked, event)

      if (response.status === 200) {
        this.$notify({
          group: 'notifications',
          type: 'success',
          text: 'Status alterado com sucesso'
        })
        await this.updateDataTable()
      } else {
        this.$notify({
          group: 'notifications',
          type: 'error',
          text: 'Ocorreu um erro ao atualizar o status, por favor tente novamente!'
        })
      }
    }
  }
}
</script>

<style lang="scss">
</style>
